import { memo } from 'preact/compat';
import {useEffect, useState} from "preact/hooks";
import style from './style.css'

import { getTotal } from '../../helpers'

function areEqual(prevProps, nextProps) {
  // true prevents render
  // return false if quantities changed
  return prevProps.quantities === nextProps.quantities
  //return true
}

const StripeElement = ({ stripe, onCardSuccess, products, quantities }) => {
  const [elements, setElements] = useState(null)
  const [card, setCard] = useState(null)
  const [stripeValid, setStripeValid] = useState(false)
  const [formData, setFormData] = useState({quantity: 1})
  const [error, setError] = useState(null)

  useEffect(() => {
    const elements = stripe.elements()
    const card = elements.create('card', {
      style: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '18px',
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
    });
    card.mount('#cc-form');
    card.on('change', function(event) {
      setStripeValid(event.complete && !event.error)
    });

    setElements(elements)
    setCard(card)
  }, [])

  const onSubmit = () => {
    setError(false)

    stripe.createToken(card).
      then(res => {
        console.log('stripe result', res)
        if (res.error) {
          setError(res.error.message)
        } else {
          onCardSuccess({
            ...formData,
            stripe: res.token
          })
        }
      }).
      catch(err => {
        console.log('stripe error, show something', err)
        setError(err)
      });
  }

  const formValid = () => {
    // at least 1 item selected
    if (Object.values((quantities||{})).reduce((acc,val) => acc+(val.quantity||0), 0) <= 0) return false

    // pii present
    if (!formData.email || !formData.email.match(/\@/)) return false
    if (!formData.name || !formData.name.length > 3) return false
    if (!formData.phone || !formData.phone.length > 3) return false
    return true
  }

  const currentPrice = () => {
    return getTotal(products, quantities);
  }

  return (
    <div class={style.FormGroup} id='checkout-form'>
      <div class={style.FormRow}>
        <b>Email</b> <input type="text" value={formData.email} onInput={(e) => setFormData({...formData, email: e.target.value})} />
      </div>
      <div class={style.FormRow}>
        <b>Name</b> <input type="text" value={formData.name} onInput={(e) => setFormData({...formData, name: e.target.value})} />
      </div>
      {products[0].allow_proxy && (
        <div class={style.FormRow}>
          <b>Proxy Name</b> <input type="text" value={formData.proxy_name} onInput={(e) => setFormData({...formData, proxy_name: e.target.value})} />
        </div>
      )}
      <div class={style.FormRow}>
        <b>Phone</b> <input type="text" value={formData.phone} onInput={(e) => setFormData({...formData, phone: e.target.value})} />
      </div>
      
      <div id="cc-form" class={style.CCForm}></div>

      <div class={style.FormRow}>
        <div style="margin:auto; padding:5px">
          Fees: ${currentPrice().fees.toFixed(2)} / Sales Tax: ${currentPrice().taxes.toFixed(2)}
        </div>
      </div>
      <div class={style.FormRow}>
        <button type="submit" onClick={() => onSubmit()} disabled={!stripeValid || !formValid() ? 'disabled':''}>
          {products[0].raffle_is_live ? 'Enter Raffle' : 'Buy Now'}: ${currentPrice().total.toFixed(2)}
        </button>
      </div>
      {error && (
        <div class={style.FormRow}>
          <b>
            There was an error processing this card: {error}
            Please confirm your details are correct and try again.
          </b>
        </div>
      )}
    </div>
  )
}

export default memo(StripeElement, areEqual)